import { t } from '../i18n/idioma';
import { formatGold } from './itemUi';

export function prata(n: number): string {
  return formatGold(n);
}

export function relogioDe(iso: string): { texto: string; urg: string } {
  const s = Math.max(0, Math.floor((Date.parse(iso) - Date.now()) / 1000));
  const urg = s < 1800 ? 'rel--urg' : s < 7200 ? 'rel--logo' : '';
  if (s < 3600) return { texto: t('mercado.minutos', { n: Math.floor(s / 60) }), urg };
  if (s < 86400) {
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    return { texto: t('mercado.horasMin', { h, m: String(m).padStart(2, '0') }), urg };
  }
  return { texto: t('mercado.diasHoras', { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600) }), urg };
}

export const HORAS = [12, 24, 48] as const;

export function aliquotaDe(horas: number): number {
  if (horas === 24) return 0.11;
  if (horas === 48) return 0.12;
  return 0.10;
}

export function percentualDe(horas: number): number {
  return Math.round(aliquotaDe(horas) * 100);
}

export function taxaDeAnuncio(lanceMinimo: number, compraJa: number | null, horas: number): number {
  const ref = compraJa != null ? Math.max(lanceMinimo, compraJa) : lanceMinimo;
  return Math.max(1, Math.round(ref * aliquotaDe(horas)));
}

export function comissaoDe(martelo: number): number {
  return Math.round(martelo * 0.04);
}
